export default __webpack_public_path__ + "static/media/pos-stone.2fc206e6.jpg";